<template>
	<TwoPartsTreeBlock v-on="$listeners" :isChosen="isChosen">
		<template #first-part>
			<FlowTreeActionBlock disabled v-on="$listeners" :actionData="{}" :appData="notificationServiceMock" :blockData="blockData" />
		</template>
		<template #second-part>
			<Row class="height-100 width-100 flex-centerize overflow-hidden">
				<BuilderNotification class="notification" :icon="notification.icon" v-bind="notificationPreviewProps" />
			</Row>
		</template>
	</TwoPartsTreeBlock>
</template>

<script>
import { mapGettersShorthand } from '@/store/utils/mappers';
import { flatPreviousSteps } from '@/store/modules/selectedNode/getters';
import { editNode } from '@/store/modules/selectedNode/getters';

import * as WorkflowNodeService from '@/utils/workflow-node-service';
import BuilderNotification from '@/components/BlockEditorNotification/PreviewTabs/BuilderNotification.vue';
import TwoPartsTreeBlock from './TwoPartsTreeBlock.vue';
import FlowTreeActionBlock from './FlowTreeActionBlock.vue';
import { ServiceSlugs } from '@ply-io/ply-front-shared-utilities';

export default {
	name: 'NotificationTreeBlock',
	components: {
		TwoPartsTreeBlock,
		FlowTreeActionBlock,
		BuilderNotification,
	},
	props: { blockData: { Object }, notification: { type: Object } },
	computed: {
		...mapGettersShorthand({ flatPreviousSteps, editNode }),
		notificationPreviewProps() {
			return WorkflowNodeService.getNotificationTranslatedProps(this.notification, this.flatPreviousSteps);
		},
		notificationServiceMock() {
			return {
				service_slug: ServiceSlugs.Notification,
			};
		},
		isChosen() {
			return this.editNode?.id === this.blockData.id;
		},
	},
};
</script>
<style lang="scss" scoped>
.notification {
	transform: scale(0.67);
}
::v-deep {
	.ui-element-container {
		max-width: 100% !important;
		// min-width: 430px !important;
	}
}
</style>
